import { No } from './no.model';

export class Funcionalidade {
    nome: string;
    status:string = "Sem Acesso";
    acesso:string;

    constructor(nome:string, acesso?:string) {

        this.nome = nome;
        this.acesso = acesso;
    }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/arvore-acesso/funcionalidade.model.ts